export const SEARCH_SCHEDULED_EMAIL_ASYNC = 'SEARCH_SCHEDULED_EMAIL_ASYNC';
export const SEARCH_SCHEDULED_EMAIL_SUCCESS = 'SEARCH_SCHEDULED_EMAIL_SUCCESS';
export const RESET_SCHEDULED_EMAIL = 'RESET_SCHEDULED_EMAIL';



// WEBPACK FOOTER //
// ./src/Activities/constants.js